export default __webpack_public_path__ + "static/underline-92d4acb0723d6379b9b12269e07cca51.svg";